<fury-page-layout mode="card">
   
      <fury-page-layout-header>
        <div class="top_heading">
          <fury-breadcrumbs [@fadeInRight]  current="Lead Partner Dashbaord"></fury-breadcrumbs>
          <div class="daterange">
            <mat-form-field class="example-form-field" appearance="outline">
            <mat-label>Date Range</mat-label>
                <mat-date-range-input
                [formGroup]="dateRangePickerForm"
                [rangePicker]="campaignOnePicker"
                [max]="today" (click)="campaignOnePicker.open()">
                <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
                <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd>
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #campaignOnePicker>
                    <mat-date-range-picker-actions>
                        <button class="apply" mat-raised-button color="primary" matDateRangePickerApply (click)="dateRangeChange(dateRangeStart, dateRangeEnd)">Apply</button>
                        <button class="can" mat-button matDateRangePickerCancel (click)="clearDaterangePicker()">Clear</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
                <mat-error *ngIf="dateRangePickerForm.controls['start'].touched && dateRangePickerForm.controls['start'].value && !dateRangePickerForm.controls['end'].value">Please select end date</mat-error>
            </mat-form-field>
        </div>
        </div>
      </fury-page-layout-header>
    
      <fury-page-layout-content [@fadeInUp]>
        <ul class="listcont">
            <li>
                ROI
                <span class="green">{{dashboardData?.roi | number}}%</span>
            </li>
            <li>
                GROSS CONVERSION
                <span class="red">{{dashboardData?.grossConversionRate | number}}%</span>
            </li>
            <li>
              NET CONVERSION
              <span class="orenge">{{dashboardData?.netConversionRate | number}}%</span>
          </li>
            <li>
                SCORE
                <span class="red">{{dashboardData?.score | number}} Points</span>
            </li>
            <li>
                QUALITY
                <span class="blue">{{dashboardData?.quality | number}}%</span>
            </li>
            <li>
                CPS
                <span class="green">{{dashboardData?.cps | currency}}</span>
            </li>
            <li>
                TOTAL COST
                <span class="orenge">{{dashboardData?.totalCost | currency}}</span>
            </li>
            <li>
                NET EARNINGS
              <span class="red">{{dashboardData?.netEarnings | currency}}</span>
          </li>
           <li>
            GROSS EARNINGS
          <span class="blue">{{dashboardData?.grossEarnings | currency}}</span>
      </li>
        </ul>
      </fury-page-layout-content>
    </fury-page-layout>